// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".icon-modulo[data-v-748596e0]{width:10px;height:auto}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
